import { useMutation } from '@tanstack/react-query';
import { updatePushTokenTimezone } from 'shared/services/backend-api';

export const useUpdatePushTokenTimezoneMutation = () =>
  useMutation({
    mutationFn: async ({
      token,
      timezone,
    }: {
      token: string;
      timezone: string;
    }) => updatePushTokenTimezone(token, timezone),
  });
